import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { SessionService } from '@src/app/modules/auth';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPageComponent {
  private readonly session = inject(SessionService);

  selectLanguage: string = 'EN';
  readonly languages: string[] = [
    // 'RU',
    'EN',
  ];

  policyStartDate = '2022-07-02';

  get appName() {
    return this.session.appConfig?.shortName;
  }
}
